export const formatVideoVolumeSliderTooltip = (values: number[]) => {
  return `${Math.round(values[0] * 100)}%`;
};
